export var state = {
  sla: [],
  slaLevels: [],
  slaConfigurations: []
};